<template>
  <v-container fluid>
    <v-row justify="center" align="start" class="py-5">
      <Client v-for="n in clients" :key="'client-' + n" class="ma-5"></Client>
    </v-row>
    <v-row justify="center" align="center" class="py-5">
      <v-btn @click="addClient">Add Client</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import Client from '../components/Client';

export default {
  name: 'Playground',
  components: { Client },
  data() {
    return {
      clients: 3,
    };
  },
  methods: {
    addClient() {
      this.clients++;
    },
  },
};
</script>

<style scoped></style>
